import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/ccsApi";

export default function Feedback({ mode, calculationId }) {
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);
    const [comment, setComment] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [done, setDone] = useState(false);

    async function submit(e) {
        e.preventDefault();
        if (rating === 0) { toast.error("Please choose a star rating"); return; }
        setSubmitting(true);
        try {
            await api.post("/feedback", { rating, comment, mode, calculation_id: calculationId });
            setDone(true);
            toast.success("Thanks for the feedback");
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setSubmitting(false);
        }
    }

    if (done) {
        return (
            <div className="ccs-card border-[#22C55E]/40 bg-[#F0FDF4]" data-testid="feedback-thanks">
                <div className="font-heading font-semibold text-[#0F172A]">Thanks — your feedback helps improve this tool.</div>
            </div>
        );
    }

    return (
        <form onSubmit={submit} className="ccs-card" data-testid="feedback-form">
            <h3 className="font-heading font-semibold text-lg text-[#0F172A]">Was this calculator helpful?</h3>
            <p className="text-sm text-slate-600 mt-1">Rate it and (optionally) tell us how to improve it.</p>
            <div className="mt-3 flex items-center gap-1" data-testid="feedback-stars">
                {[1, 2, 3, 4, 5].map((n) => {
                    const active = n <= (hover || rating);
                    return (
                        <button
                            key={n}
                            type="button"
                            onMouseEnter={() => setHover(n)}
                            onMouseLeave={() => setHover(0)}
                            onClick={() => setRating(n)}
                            aria-label={`${n} star${n > 1 ? "s" : ""}`}
                            data-testid={`feedback-star-${n}`}
                            className="p-1 transition-transform hover:scale-110"
                        >
                            <Star className={`h-7 w-7 ${active ? "text-[#F59E0B] fill-[#F59E0B]" : "text-slate-300"}`} />
                        </button>
                    );
                })}
                {rating > 0 && <span className="ml-2 text-sm text-slate-500">{rating} / 5</span>}
            </div>
            <Textarea
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Optional: anything we could improve?"
                className="mt-3 bg-white"
                rows={3}
                data-testid="feedback-comment"
            />
            <div className="mt-3 flex justify-end">
                <Button type="submit" disabled={submitting} className="ccs-btn-secondary rounded-full" data-testid="submit-feedback">
                    {submitting ? "Sending…" : "Submit feedback"}
                </Button>
            </div>
        </form>
    );
}
